// extracted by mini-css-extract-plugin
export default {"legacy-wrapper":"legacy-wrapper_Ma0i6sBO"};